<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    @keydown.esc="cancel"
    persistent
  >
    <v-card>
      <v-card-title><i class="fas fa-info-circle"></i></v-card-title>
      <template v-if="!!message">
        <template v-if="Array.isArray(message)">
          <v-card-text class="confirm-dialog-message">
            <p v-for="(value, key) in message" :key="key">
              {{ value }}
            </p>
          </v-card-text>
        </template>
        <template v-else>
          <v-card-text style="white-space:pre-wrap;">{{ message }}</v-card-text>
        </template>
      </template>
      <template v-else>
        <v-card-text></v-card-text>
      </template>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="btn-primary" @click.native="agree">
          {{ buttonText }}
        </v-btn>
        <v-btn class="btn-primary" @click.native="cancel">
          キャンセル
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
    message: null,
    buttonText: null,
    options: {
      width: 400
    }
  }),
  methods: {
    open(message, buttonText, options) {
      this.dialog = true;
      this.message = message;
      this.buttonText = buttonText;
      this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    }
  }
};
</script>
